import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import {
  Card,
  Box,
  Typography,
  Button,
  Icon,
  Divider,
  Grid
} from '@material-ui/core';
import { ArrowLeftIcon } from 'components/CustomSVG';
import { Breadcrumb } from 'components';
import { useStyles } from '../styles';
import QuoteSummaryPatient from '../QuoteSummary/QuoteSummaryPatient';
import QuoteTreatmentPlanTable from './QuoteTreatmentPlanTable';
import QuoteTreatmentPlanSummaryBlock from './QuoteTreatmentPlanSummaryBlock';


const QuoteTreatmentPlanPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams<{id?: string}>();

  const {
    currentQuoteCustomer,
    customerPushCart,
    quotePlan
  } = useSelector((state: IReduxState) => state.quote);
  const {
    userStoreData: {storeCode}
  } = useSelector((state: IReduxState) => state.user);

  useEffect(() => {
    if (!customerPushCart?.treatments?.length) {
      history.push(`/quoting/profile/${id}`);
    }
  }, [customerPushCart?.treatments?.length]);

  const isCustomer3 = storeCode === 'customer3';

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting'},
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`,
              path: `/quoting/profile/${id}`},
            { name: 'Quote Workspace', path: `/quoting/profile/${id}/quote-workspace` },
            { name: 'Quote Summary', path: `/quoting/profile/${id}/quote-workspace/summary` },
            { name: 'Configure Plan' }
          ]}
        />
      </div>
      <Grid container spacing={3} className="px-8">
        <Grid item xs={12} md={8}>
          <Card className="p-4 root-card">
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <Box display="flex" alignItems="center">
                <Typography variant="h5" gutterBottom>
                  Items ({quotePlan.length})
                </Typography>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className={`${classes.quoteSummaryCTAButton} mr-2`}
                  onClick={() => history.push(
                    { pathname: `/quoting/profile/${currentQuoteCustomer?.id}/quote-workspace/summary` }
                  )}
                >
                  <ArrowLeftIcon className="mr-1" />
                  Go Back to Individual Items
                </Button>
                <Button
                  variant="outlined"
                  className={classes.quoteSummaryCTAButton}
                  onClick={() => history.push(
                    { pathname: `/quoting/profile/${id}/quote-workspace` }
                  )}
                >
                  <Icon fontSize="small" className="mr-1">
                    edit
                  </Icon>
                  Edit
                </Button>
              </Box>
            </Box>
            <Divider />
            <QuoteTreatmentPlanTable />
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <QuoteSummaryPatient />
          <QuoteTreatmentPlanSummaryBlock />
        </Grid>
      </Grid>
    </div>
  );
};

export default QuoteTreatmentPlanPage;
